module.exports = __webpack_public_path__ + "img/identifier.6ae65dce.png";